import React from 'react';
import { TableRow, TableHeader } from '@unimed-fesp/components';

const TableHeaderRelatorios = () => {
  return (
    <TableRow>
      <TableHeader>Nome arquivo</TableHeader>
      <TableHeader>Status</TableHeader>
      <TableHeader>Dt. requerimento</TableHeader>
      <TableHeader>Dt. finalização</TableHeader>
      <TableHeader>Download</TableHeader>
    </TableRow>
  );
};

export default TableHeaderRelatorios;
